document.addEventListener('alpine:init', () => {
    Alpine.data('navigation', function () {
        return {
            menuIsOpen: false,
            menuPanel: 'menu',
            findAFundIsOpen: false,
            findAFundFormSubmit: false,
            favouriteFundsIsOpen: false,
            favouriteFunds: this.$persist([]),
            territorySelect(href) {
                //keeping this function incase there is any additional logic we need to do here. For example IP detection
                this.isOpen = false;
                window.location.href = href;
            },
            onFindAFundSearchFieldChange(e) {
                this.findAFundFormSubmit = e.target?.value?.length;
            },
            init() {
                // Add test data for favourite funds
                this.favouriteFunds = [
                    {
                        id: 1,
                        name: 'iMGP Absolute Return GBP Fund',
                        url: '',
                    },
                    {
                        id: 2,
                        name: 'iMGP Absolute Return GBP Fund',
                        url: '',
                    },
                    {
                        id: 3,
                        name: 'iMGP Absolute Return GBP Fund',
                        url: '',
                    }
                ];
            }
        }
    });
});

document.addEventListener('alpine:init', () => {
    Alpine.data('menuItem', () => ({
        subMenuIsOpen: false,
    }));
});
